import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "banner-content" }
const _hoisted_2 = { href: "#" }
const _hoisted_3 = { class: "up" }
const _hoisted_4 = { class: "inn" }
const _hoisted_5 = { class: "down" }
const _hoisted_6 = { class: "inn" }

import { ref, onMounted, computed, onBeforeUnmount, watch } from "vue";
import { useI18n } from "vue-i18n";


const __default__ = {
  name: "BannerWidget",
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    config: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "02201a18": (_ctx.config.fontColor),
  "6cbde575": (_ctx.config.backgroundColor)
}))

const props = __props;

const { t } = useI18n();

const currentTextIndex = ref(0);
const previousTextIndex = ref(0);
const isFlipping = ref(false);
const flipTimer = ref<number | null>(null);

const fontSize = computed(() => {
  // Calculate font size based on banner height and width
  return Math.floor(Math.min(props.config.height, props.config.width) * 0.8);
});

const boxShadowColor = computed(() => {
  return hexToRgba(props.config.backgroundColor, 0.7);
});

function hexToRgba(hex: string, alpha: number) {
  let c = hex.replace("#", "");
  if (c.length === 3)
    c = c
      .split("")
      .map((x) => x + x)
      .join("");
  const num = parseInt(c, 16);
  return `rgba(${(num >> 16) & 255}, ${(num >> 8) & 255}, ${
    num & 255
  }, ${alpha})`;
}

function triggerFlipAnimation() {
  const element: any = document.querySelector(".flip-text");
  if (element) {
    element.classList.remove("play");
    void element.offsetWidth; // Force reflow
    element.classList.add("play");
  }
}

function nextText() {
  if (!props.config.texts || props.config.texts.length === 0) return;

  previousTextIndex.value = currentTextIndex.value;
  currentTextIndex.value =
    (currentTextIndex.value + 1) % props.config.texts.length;

  isFlipping.value = true;
  triggerFlipAnimation();

  // Reset flip state after animation
  setTimeout(() => {
    isFlipping.value = false;
  }, 1000);
}

onMounted(() => {
  if (props.config.texts && props.config.texts.length > 1) {
    const duration = parseInt(props.config.transitionDuration) || 3000;
    flipTimer.value = window.setInterval(nextText, duration);
  }
});

onBeforeUnmount(() => {
  if (flipTimer.value) {
    window.clearInterval(flipTimer.value);
  }
});

// Watch for config changes to restart timer
watch(
  () => props.config.transitionDuration,
  (newDuration) => {
    if (flipTimer.value) {
      window.clearInterval(flipTimer.value);
    }
    if (props.config.texts && props.config.texts.length > 1) {
      const duration = parseInt(newDuration) || 3000;
      flipTimer.value = window.setInterval(nextText, duration);
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "banner-widget",
    style: _normalizeStyle({
      backgroundColor: _ctx.config.backgroundColor,
      color: _ctx.config.fontColor,
      width: '100%',
      height: '100%',
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", {
        class: _normalizeClass(["flip flip-text", { play: isFlipping.value }]),
        style: _normalizeStyle({
          height: '100%',
          fontSize: fontSize.value + 'px',
          boxShadow: `0 2px 5px ${boxShadowColor.value}`,
        })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.texts, (textObj, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: `text-${index}`,
            class: _normalizeClass({
            active: index === currentTextIndex.value,
            before: index === previousTextIndex.value,
          })
          }, [
            _createElementVNode("a", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "shadow" }, null, -1)),
                _createElementVNode("div", _hoisted_4, _toDisplayString(textObj.text), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "shadow" }, null, -1)),
                _createElementVNode("div", _hoisted_6, _toDisplayString(textObj.text), 1)
              ])
            ])
          ], 2))
        }), 128))
      ], 6)
    ])
  ], 4))
}
}

})